"use client";

import { Alert, Button, Space } from "antd";
import { useEffect } from "react";
import { trackClientError } from "@/lib/datadog";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    void trackClientError(error, { digest: error.digest });
  }, [error]);

  return (
    <div className="p-4">
      <Alert
        type="error"
        showIcon
        title="Something went wrong"
        description={
          <Space orientation="vertical" className="w-full">
            <span className="text-ink-secondary text-13">{error.message}</span>
            <Button size="small" onClick={reset}>
              Retry
            </Button>
          </Space>
        }
      />
    </div>
  );
}
